module.exports = __webpack_public_path__ + "img/scheme3.6a3dbb41.png";